import { LearnMoreGenericAccordion } from 'core/Components';
import { Box, ButtonMantine, Modal, Stack } from 'ui';

import useGtmServices from '../../hooks/useGtmServices';

interface Props {
  isLearnMoreOpen: boolean;
  setIsLearnMoreOpen: (boolean: boolean) => void;
  handleEnrollOnWeb: () => void;
  handleGetApp: () => void;
}

const LearnMoreDrawer = ({
  isLearnMoreOpen,
  setIsLearnMoreOpen,
  handleEnrollOnWeb,
  handleGetApp,
}: Props) => {
  const GtmService = useGtmServices();
  return (
    <Modal
      opened={isLearnMoreOpen}
      onClose={() => setIsLearnMoreOpen(false)}
      title={'Learn More'}
      variant="full-screen-mobile"
    >
      <Stack justify="space-between" h="90%" pb={24}>
        <Box style={{ overflow: 'scroll', height: '75%' }}>
          <LearnMoreGenericAccordion variant="separated" />
        </Box>
        <Stack gap="md" w="100%" style={{ zIndex: 10 }} bg="white">
          <ButtonMantine
            fullWidth={true}
            onClick={() =>
              GtmService.click(handleGetApp, {
                type: 'button',
                action: 'download_app',
                label: 'Get the App',
              })
            }
          >
            Get the App
          </ButtonMantine>
          <ButtonMantine
            fullWidth={true}
            variant="text"
            onClick={() =>
              GtmService.click(handleEnrollOnWeb, {
                type: 'button',
                action: 'sign_up',
                label: 'Enroll on web',
              })
            }
          >
            Enroll on web
          </ButtonMantine>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default LearnMoreDrawer;
